<template>
  <div v-show="active" :id="elementId" class="notification-message" :class="[classes, brandClass()]">
    <div class="message_info_icon"></div> 
    <div class="message_info_icon_cake">&#127874;</div>
    <div v-if="message.prefix" class="message_content">{{message.prefix}}<a :class="brandClass()" @click="click($event)" href="#" role="button">{{message.content}}</a>{{message.suffix}}</div>
    <div v-else class="message_content">{{ content }}</div> 
    <div class="close_icon pointer" id="message-close"  @keydown="ariaClick" role="button" tabindex="1" :aria-label="$t('close_message')" @click="clearMessage"></div>
  </div>
</template>

<script>
import oneUtils from "../../gcdm-one-library/gcdm-one-utils/src/bootstrap";
export default {
      inject:['$c', '$t', 'brandClass'],
  mixins: [oneUtils.accessibilityMixin],
  name: "Message",
  props: {
    elementId: {
      type: String,
      required: false,
      default: 'app-notification-message'
    }
  },
  computed: {
    message() {
      return this.$store.getters.getMessage;
    },
    type() {
      return this.message?.type;
    },
    classes() {
      const classes = {
      };
      if (this.type?.toString().toLowerCase()){
        classes[this.type?.toString().toLowerCase()] = true;
      }
      if(this.$c('show_profile_header')){
        classes['top-for-header'] = true
      }
      return classes;
    },
    content() {
      return this.message?.content;
    },
    active: {
      get: function () {
        return !!this.content;
      },
    },
  },
  watch:{
    content:{
      deep: true,
      handler(newValue) {
        if(newValue){
          setTimeout(() => {
            document.getElementById('message-close').focus();
          }, 200);
        }
      }
    }
  },
  methods: {
    click(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      this.message.click();
    },
    clearMessage() {
      oneUtils.utils.hideMessage();
    },
  },
};
</script>

<style lang="scss">
#app{
  .notification-message {
    position: absolute;
    left: 0;
    right: 0;
    text-align: left;
    padding: 14px 7%;
    background: white;
    z-index: 25;
    display: flex;
    align-items: center;
    font-size: 12px;



    .message_info_icon_cake{
      font-size: 16px;
      display: none;
    }
    &.top-for-header{
      position: sticky;
      top: 0;
    }
    .message_info_icon{
      background-image: url('~@/assets/default/light/message-info-default-light.svg');
      width: 16px;
      height: 14px;
      background-repeat: no-repeat;
    }
    .close_icon{
      background-image: url('~@/assets/default/light/message-info-close-default-light.svg');
      width: 10px;
      height: 9px;
      background-repeat: no-repeat;
      margin-left: auto;
      &:hover{
        outline: auto;
      }
    }
    .message_content{
      width: 90%;
      margin-left: 16px;
      margin-right: 8px;
      a{
        font-weight: bold;
      }
    }
    &.error {
      color: $messageerror !important;
      background-color: $messageerrorbg;
      a{
        &.__alphabet{
          color: $messageerror !important;
        }
      }
      .close_icon{
        background-image: url('~@/assets/default/light/message-error-close-default-light.svg');
      }
      .message_info_icon{
        background-image: url('~@/assets/default/light/message-error-default-light.svg');
      }
    }
    &.birthday {
      color: $black !important; 
      background-color: $messageinfobg !important;
      a{
        &.__alphabet{
          color: $black !important;
        }
      }
      .message_info_icon{
        background-image: none !important;
      }
      .message_info_icon_cake {
        display: block;
      }
    }
    &.warning {
      color: $black !important; 
      background-color: $messagewarningbg;
      a{
        &.__alphabet{
          color: $black !important;
        }
      }
    }
    &.success {
      color: $messagesuccess !important; 
      background-color: $messagesuccessbg;
      a{
        &.__alphabet{
          color: $messagesuccess !important;
        }
      }
      .close_icon{
        background-image: url('~@/assets/default/light/message-success-close-default-light.svg');
      }
      .message_info_icon{
        background-image: url('~@/assets/default/light/message-success-default-light.svg');
      }
    }
    &.info {
      color: $black !important; 
      background-color: $messageinfobg !important;

      a{
        &.__alphabet{
          color: $black !important;
        }
      }
    }
    &.__m{
  
      padding: 30px 7%;
      font-size: 18px;
      .message_content{
        width: 85%;
      }
      &.top-for-header{
        position: sticky;
        top: 0;
      }
      .message_info_icon{
        background-image: url('~@/assets/mini/light/message-info-mini-light.svg');
        width: 26px;
        height: 26px;
        background-size: contain;
        background-position: center;
      }
      .close_icon{
        background-image: url('~@/assets/mini/light/message-info-close-mini-light.svg');
        width: 26px;
        height: 26px;
        background-size: contain;
        background-position: center;
      }
      &.error {
        color: $messageerrormini !important;
        background-color: $messageerrorbgmini;
        .close_icon{
          background-image: url('~@/assets/mini/light/message-error-close-mini-light.svg');
        }
        .message_info_icon{
          background-image: url('~@/assets/mini/light/message-error-mini-light.svg');
        }
      }
      &.warning {
        color: black !important; 
        background-color: $messagewarningbg;
        
      }
      &.success {
        color: $messagesuccessmini !important;
        background-color: $messagesuccessbgmini;
        .close_icon{
          background-image: url('~@/assets/mini/light/message-info-close-mini-light.svg');
        }
        .message_info_icon{
          background-image: url('~@/assets/mini/light/message-info-mini-light.svg');
        }
      }
      &.info {
        color: black !important; 
        background-color: $messageinfobg;
      }
  
    }
    &.__rr {
      position: sticky;
      top: 0;
    }
    &.__d{
      a{
        color: black;
      }
    } 

    //small desktop
    @media screen and (max-width: 1024px) {
  
      padding: 14px 7%;
      position: fixed;
      top: 0;
  
    }
  }
}
</style>



